import { ButtonBase } from "@mui/material";
import {
  invoiceDesignFontFamily,
  invoiceDesignTokens,
} from "../Invoicing/InvoiceDesignSystem";

export type ProspectStatusFilter = "All" | "Active" | "Converted";

export const ProspectStatusTabs = ({
  value,
  onChange,
}: {
  value: ProspectStatusFilter;
  onChange: (value: ProspectStatusFilter) => void;
}) => (
  <div
    aria-label="Prospect status"
    className="flex self-end gap-1 rounded-lg border border-[#ECECEC] p-[3px]"
    role="group"
  >
    {(["All", "Active", "Converted"] as const).map((status) => (
      <ButtonBase
        aria-pressed={value === status}
        key={status}
        onClick={() => onChange(status)}
        sx={{
          backgroundColor:
            value === status ? invoiceDesignTokens.gold : "transparent",
          borderRadius: "6px",
          color: value === status ? "#FFFFFF" : invoiceDesignTokens.ink,
          fontFamily: invoiceDesignFontFamily,
          fontSize: 13,
          fontWeight: 600,
          lineHeight: "normal",
          padding: "8px 16px",
          "&.Mui-focusVisible": {
            outline: `2px solid ${invoiceDesignTokens.goldDark}`,
            outlineOffset: 2,
          },
        }}
        type="button"
      >
        {status}
      </ButtonBase>
    ))}
  </div>
);
